import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./programs.css";

const Programs = () => {
  const navigate = useNavigate();

  const programs = [
    {
      title: "⚡ 1-Week Bootcamp",
      description: "Crash course for quick upskilling in trending technologies.",
    },
    {
      title: "📅 1-Month Intensive",
      description: "Deep dive training with projects and mentorship.",
    },
    {
      title: "🗓️ Weekend Program",
      description: "Flexible learning designed for working professionals.",
    },
    {
      title: "1️⃣ 1-Year Program",
      description:
        "Accelerated program for upskilling and staying updated with latest technologies.",
    },
    {
      title: "🚀 Fast-Track Program",
      description:
        "Accelerated program for career changers and freshers.",
    },
  ];

  return (
    <div className="programs-container">
      <h1 className="programs-title">🎯 Our Programs</h1>
      <p className="programs-subtitle">
        Discover flexible short-term programs and long-term programs designed for rapid skill building.
      </p>

      <div className="programs-grid">
        {programs.map((program, idx) => (
          <motion.div
            key={idx}
            className="program-card"
            whileHover={{ scale: 1.05, rotate: 1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() =>
              navigate("/skillupgrade/enroll", { state: { courseName: program.title } })
            }
          >
            <h2>{program.title}</h2>
            <p>{program.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Programs;
